export const AccountImages = {
  alertIcon: require('./alert.svg'),
  accountBackgroundLogo: require('./accountBackgroundLogo.svg'),
  backgroundLogo: require('./background.svg'),
  settingsIcon: require('./settings.svg'),
  logout: require('./logout.svg'),
  download: require('./download.svg'),
  create: require('./create.svg'),
  login: require('./login.svg'),
  recovery: require('./recovery.svg'),
  view: require('./view.svg'),
  share: require('./share.svg'),
  unShared: require('./unShared.svg'),
  mail: require('./mail.svg'),
  delete: require('./delete.svg'),
  mobile: require('./mobile.svg'),
  calendar: require('./calendar.svg'),
  recoveryBackground: require('./recoveryBackground.svg'),
  activity: require('./noActivity.svg'),
  burn: require('./burn.svg'),
  update: require('./refresh.svg'),
};
